import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { Box, Container } from "@material-ui/core";
import NavbarComponent from "../components/Navbar/NavbarComponent";
import Features from "../components/Features/Features";
import EmailUs from "../components/EmailUs/EmailUs";
import FarmerStats from "./../components/FarmerStats/FarmerStats";
import FeeSection from "../components/FeeSection/FeeSection";
import WhyCEFA from "./../components/WhyCEFA/WhyCEFA";
import Tokenomics from "../components/Tokenomics/Tokenomics";
import Profits from "../components/Profits/Profits";
import Roadmap from "../components/Roadmap/Roadmap";
import Footer from "../components/Footer/Footer";

const useStyles = makeStyles(theme => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  bg_one: {
    flexDirection: "column",
    justifyContent: "center",
    backgroundPosition: "absolute",
    backgroundSize: "cover",
    minHeight: "1480px",
    zIndex: 2,

    width: "100%",
    overflow: "hidden",

    [theme.breakpoints.down("sm")]: {
      minHeight: "1000px"
    }
  },
  navbar: {
    height: "93px",
    marginTop: "55px"
  }
}));

export default function Landing(props) {
  const classes = useStyles();
  return (
    <div>
      <NavbarComponent {...props} />
      <Features {...props} />
      <EmailUs {...props} />
      {/* <FarmerStats /> */}
      <Tokenomics />
      <FeeSection />
      <WhyCEFA />
      <Profits />
      <Roadmap />
      <Footer />
    </div>
  );
}
